import React from 'react';
import PropTypes from 'prop-types';

export default function IconWithText({
  iconClassName, iconStyle, iconBg, iconBgStyle, contentClassName, wrapperClassName, children,
}) {
  return (
    <div className={`icon-with-text ${wrapperClassName}`}>
      {iconBg ? (
        <div className={`icon-bg ${iconBg}`} style={iconBgStyle}>
          <i className={iconClassName} style={iconStyle} />
        </div>
      ) : (
        <i className={iconClassName} style={iconStyle} />
      )}

      {children && (
        <div className={`text-content ${contentClassName}`}>
          {children}
        </div>
      )}
    </div>
  );
}

IconWithText.propTypes = {
  iconClassName: PropTypes.string.isRequired,
  iconStyle: PropTypes.object,
  iconBg: PropTypes.string,
  iconBgStyle: PropTypes.object,
  contentClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  children: PropTypes.node,
};

IconWithText.defaultProps = {
  iconStyle: {},
  iconBg: '',
  iconBgStyle: {},
  contentClassName: '',
  wrapperClassName: '',
  children: null,
};
